import { CampaignListPage } from "@/features/campaign/pages/CampaignListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/campaign/")({
	component: CampaignListPage,
});
